import type { HotkeysMapProps } from "./components/HotkeysMap";
import type * as lazyIndex from "./lazyIndex";
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "HotkeysMap" */ "./lazyIndex"), { name: "HotkeysMap" });

export type { CommandCategory } from "./components/CommandCategory";
export type { HotkeysMapPropertiesResult } from "./store/schema/HotkeysMapProviderStore";

export const lazyRegisterHotkeysMapPropertiesProvider: LazyAction<typeof lazyIndex.registerHotkeysMapPropertiesProvider, typeof lazyModule> = new LazyAction(lazyModule, m => m.registerHotkeysMapPropertiesProvider);

export const lazyLaunchHotkeysMap: LazyAction<typeof lazyIndex.launchHotkeysMap, typeof lazyModule> = new LazyAction(lazyModule, m => m.launchHotkeysMap);

export const HotkeysMap: LazyComponent<HotkeysMapProps, unknown, void> = createLazyComponent(lazyModule, m => m.HotkeysMap);
